module.exports = __webpack_public_path__ + "img/orca.29f653d5.jpg";